module.exports = __webpack_public_path__ + "img/send-money.4f265039.png";